<template>
  <v-row class="ma-0 pa-0">
    <v-col cols="12" class="pa-0 ma-0">
      <v-tabs
        v-model="tab"
        centered
        grow
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab
          v-if="mostrarVista(31)"
          href="#registro_parcial"
          @click="actualizarItems('registro_parcial')"
        >
          Proveedores Registro Parcial
        </v-tab>

        <v-tab
          v-if="mostrarVista(20)"
          href="#registro_completo"
          @click="actualizarItems('registro_completo')"
        >
          Proveedores Registro Completo
        </v-tab>

        <v-tab
          v-if="mostrarVista(21)"
          href="#gestion_expediente_proveedor"
          @click="actualizarItems('gestion_expediente_proveedor')"
        >
          Gestión de Expediente de Proveedor
        </v-tab>
      </v-tabs>
          
      <v-tabs-items v-model="tab">
        <v-tab-item
          v-if="mostrarVista(31)"
          value="registro_parcial"
        >
          <registro-parcial
            ref="registro_parcial"
          ></registro-parcial>
        </v-tab-item>

        <v-tab-item
          v-if="mostrarVista(20)"
          value="registro_completo"
        >
         <registro-completo
            ref="registro_completo"
          ></registro-completo>
        </v-tab-item>

        <v-tab-item
          v-if="mostrarVista(21)"
          value="gestion_expediente_proveedor"
        >
         <gestion-expediente-proveedor
            ref="gestion_expediente_proveedor"
          ></gestion-expediente-proveedor>
        </v-tab-item>
      </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import RegistroParcial from './SolicutudesProveedores/RegistroParcial.vue'
import RegistroCompleto from './SolicutudesProveedores/RegistroCompleto.vue'
import GestionExpedienteProveedor from './SolicutudesProveedores/GestionExpedienteProveedor.vue'

export default {
  computed: {
    ...mapState(['ids_vistas'])
  },
  components:{
    RegistroParcial,
    RegistroCompleto,
    GestionExpedienteProveedor
  },
  data: () => ({
    tab: null
  }),
  methods: {
    mostrarVista(id_vista){
      if(this.ids_vistas == null || this.ids_vistas.length == 0) return false;
      return (this.ids_vistas.indexOf(id_vista) >= 0);
    },
    getItems(){
      this.actualizarItems(this.tab);
    },
    actualizarItems(refName) {
      if (this.$refs[refName] && this.$refs[refName].getItems) {
        this.$refs[refName].getItems();
      } else {
        console.warn(`No se encontró la referencia: ${refName}`);
      }
    }
  }
}
</script>